import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../../../assets/Icons";
import TaxationAccountViewAll from "../../../../../containers/Accounts/TaxationAccount/TaxationAccountViewAll";
import AdditionalRecipients from "../../../../_utils/AccountCreationComponents/AdditionalRecipients";
import AssignLabels from "../../../../_utils/AccountCreationComponents/AssignLabels";
import ContactDetails from "../../../../_utils/AccountCreationComponents/ContactDetails";
import GstDetails from "../../../../_utils/AccountCreationComponents/GstDetails";
import PanDetails from "../../../../_utils/AccountCreationComponents/PanDetails";
import SingleOptionSelector from "../../../../_utils/AccountCreationComponents/SingleOptionSelector";
import CommonBankLogo from "../../../../_utils/CommonBankLogo";
import CommonLayout from "../../../../_utils/CommonLayout";
import LargePopupRedirect from "../../../../_utils/CommonPopups/CommonLargePopupRedirect";
import SmallPopup from "../../../../_utils/CommonSmallPopup";
import { formatAccountNumber } from "../../../../_utils/FormatAccountNumber";

const TaxAccountStepConfirm = ({
  payload,
  bankAccountName,
  setShowModalPopup,
  showModalPopup,
  bankUserInfo = [],
  recipients = [],
  selectedTaxType,
  sectionCode,
  taxMeta,
  sectionMeta,
  resolveTaxIcon,
  activeType,
  setActiveType,
  setRemPan,
  setRemIFSC,
  setRemAccount,
  remIFSC,
  remAccount,
  remPan,
  setSearchPanText,
  searchPanText,
  createDisabled,
  handlefunction,
  pendingNavTarget,
  setPendingNavTarget,
  isAlertPopup,
  setAlertPopUp,
  formatTaxLabel,
}) => {
  const navigate = useNavigate();

  const handleCloseModal = useCallback(() => {
    setShowModalPopup(false);
  }, [setShowModalPopup]);

  const handleCardClick = (targetPath) => {
    setPendingNavTarget(targetPath);
    setAlertPopUp(true);
  };

  const handleLeaveConfirm = () => {
    setAlertPopUp(false);
    if (pendingNavTarget) {
      navigate(pendingNavTarget);
    }
    setPendingNavTarget(null);
  };

  const handleAlertCancel = () => {
    setAlertPopUp(false);
    setPendingNavTarget(null);
  };

  return (
    <>
      {isAlertPopup && (
        <div
          className="fixed z-z-index-max flex items-center justify-center top-left-base left-left-base w-width-full h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity"
          onClick={(e) => e.stopPropagation()}
        >
          <SmallPopup
            headerTitle="Open in full view?"
            headerFontWeight="semibold"
            headerFontColor="emphasis"
            textSize="font-lg"
            subtext="Leaving this page will exit you from current flow."
            btnOneText="Cancel"
            btnOneHandleFunction={handleAlertCancel}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText="Leave"
            btnTwoHandleFunction={handleLeaveConfirm}
            btnTwoEnabledBgColor="var(--text-primary)"
            btnTwoEnabledTextColor="var(--primary-bg)"
            btnTwoIsDisabled={false}
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoIsLoaderNeeded={true}
            btnTwoHoverOption="black"
          />
        </div>
      )}

      {showModalPopup && (
        <LargePopupRedirect
          headerTitle="Are you sure you want to create this account?"
          closeiconenabledBgColor="var(--primary-nav)"
          closeiconisLoading={false}
          closeiconhandleFunction={() => {
            setShowModalPopup(false);
            setRemPan("");
            setRemAccount("");
            setRemIFSC("");
            setActiveType("pan");
          }}
          closeicon={ICONS?.CLOSE}
          closeiconhoverOption="white"
          closeiconbtnType={"button"}
          closeiconisDisabled={false}
          closeicondisabledBgColor={""}
          closeiconbuttonRef={null}
          closeicontitle={"Close"}
          btnType={"button"}
          fullWidthRequired={false}
          ispanbankRequired={true}
          togglepan={() => {
            setActiveType("pan");
            setRemPan(payload.panNumber);
            setRemAccount("");
            setRemIFSC("");
            setSearchPanText(payload.panNumber);
          }}
          toggleBank={() => {
            setActiveType("bank");
            setRemPan("");
            setRemAccount(payload.bank_account);
            setRemIFSC(payload.ifsc_code);
            setSearchPanText(payload.panNumber);
          }}
          isbottomSectionneed={true}
          bottomHeaderTextNeed={true}
          bottomHeaderText={
            "On creating a new account, it gets added to the list of active accounts below as a 'pending' account for the PAN and Bank provided."
          }
          confirmbtnrequired={true}
          btnText={"Create"}
          isDisabled={createDisabled}
          isLoaderNeeded={true}
          isLoading={createDisabled}
          enabledBgColor={"var(--positive-act)"}
          enabledTextColor={"var(--text-primary)"}
          disabledBgColor={
            createDisabled ? "var(--positive-act)" : "var(--text-disabled)"
          }
          disabledTextColor={"var(--text-primary)"}
          outLineColor={""}
          hoverOption={"dark"}
          handleFunction={handlefunction}
        >
          <TaxationAccountViewAll
            id={payload?.id}
            type={"TaxAcc"}
            remPan={remPan}
            remAccount={remAccount}
            remIFSC={remIFSC}
            activeType={activeType}
            searchPanText={searchPanText}
            currentAccountDetails={payload}
            setOpenBeneAssociate={handleCloseModal}
            onCardNavigate={handleCardClick}
          />
        </LargePopupRedirect>
      )}

      <div className="px-padding-md lg:px-padding-base py-padding-md Qsmd:py-padding-base">
        <CommonLayout>
          <PanDetails
            previewMode={true}
            panNumber={payload.panNumber}
            legalName={payload.legalName}
          />

          <GstDetails
            previewMode={true}
            gstin={payload?.gstin}
            gst_org_name={payload?.gst_org_name}
          />

          <div className="flex flex-col bg-primary-card rounded-border-radius-md p-padding-md">
            <div className="text-text-primary font-semibold text-font-md mb-margin-md">
              Bank Details
            </div>
            <div className="flex flex-col gap-gap-md">
              <div className="flex flex-col gap-gap-xs">
                <div className="w-width-full text-text-primary font-normal capitalize text-font-md truncate">
                  {formatAccountNumber(payload?.bank_account)}
                </div>
                <div className="text-font-xs font-normal text-text-secondary">
                  Bank account number
                </div>
              </div>
              <div className="flex flex-row justify-between items-center">
                <div className="flex flex-col gap-gap-xs">
                  <div className="text-text-primary font-normal capitalize text-font-md truncate">
                    {payload?.ifsc_code}
                  </div>
                  <div className="text-font-xs font-normal text-text-secondary">
                    IFSC code
                  </div>
                </div>
                <div className="flex justify-center items-center bg-text-primary rounded-full py-padding-button-s px-padding-sm">
                  <CommonBankLogo
                    ifsc={payload?.ifsc_code}
                    variant="big"
                  />
                </div>
              </div>
            </div>
            <div className="bg-primary-bg h-px opacity-base-opacity my-margin-sm"></div>
            <div className="flex flex-col gap-gap-md">
              <div className="flex flex-col gap-gap-xs">
                <div className="w-width-full text-text-primary font-normal capitalize text-font-md truncate">
                  {bankAccountName?.toLowerCase()}
                </div>
                <div className="text-font-xs font-normal text-text-secondary">
                  Account holder's name
                </div>
              </div>
              {bankUserInfo?.length > 0 && (
                <>
                  <div className="flex flex-col gap-gap-xs">
                    <div className="w-width-full text-text-primary font-normal capitalize text-font-md truncate">
                      {bankUserInfo[0].branch || "NA"}
                    </div>
                    <div className="text-font-xs font-normal text-text-secondary">
                      Branch
                    </div>
                  </div>
                  <div className="flex flex-col gap-gap-xs">
                    <div className="w-width-full text-text-primary font-normal capitalize text-font-md truncate">
                      {bankUserInfo[0].city || "NA"}
                    </div>
                    <div className="text-font-xs font-normal text-text-secondary">
                      City
                    </div>
                  </div>
                  <div className="flex flex-col gap-gap-xs">
                    <div className="w-width-full text-text-primary font-normal capitalize text-font-md truncate">
                      {bankUserInfo[0].district || "NA"}
                    </div>
                    <div className="text-font-xs font-normal text-text-secondary">
                      District
                    </div>
                  </div>
                  <div className="flex flex-col gap-gap-xs">
                    <div
                      className="w-width-full text-text-primary font-normal capitalize text-font-md"
                      style={{ wordBreak: "break-word" }}
                    >
                      {bankUserInfo[0].address || "NA"}
                    </div>
                    <div className="text-font-xs font-normal text-text-secondary">
                      Address
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>

          <ContactDetails
            previewMode={true}
            accountName={payload?.account_name}
            contactNumber={payload?.contact_no}
            emailId={payload?.email_id}
          />

          <div className="flex flex-col gap-gap-md">
            <SingleOptionSelector
              previewMode
              title="Tax Type"
              selectedOption={selectedTaxType}
              metaMap={taxMeta}
              iconResolver={resolveTaxIcon}
              // getLabel={(item) => formatTaxLabel(item?.name)}
              // getKey={(item) => item?.name?.toLowerCase()}
              getLabel={(item) => formatTaxLabel(item?.name)}
              getKey={(item) => item?.name?.toLowerCase()}
            />

            {selectedTaxType?.name?.toLowerCase() === "tds" && sectionCode && (
              <SingleOptionSelector
                previewMode
                title="Tax Section"
                selectedOption={{ name: sectionCode }}
                metaMap={sectionMeta}
                showIcon={false}
              />
            )}
          </div>

          <AssignLabels
            previewMode={true}
            labels={payload?.labels}
            isOptional={true}
          />
          <div className=" pb-padding-md Qlg:pb-padding-base">
            <AdditionalRecipients
              previewMode={true}
              recipients={recipients}
            />
          </div>
        </CommonLayout>
      </div>
    </>
  );
};

export default TaxAccountStepConfirm;
